const List = () => import('./List.vue')
const Edit = () => import('./Edit.vue')
const Show = () => import('./Show.vue')
import Admin from './admin'
const Dashboard = () => import('./Dashboard.vue')
const Roster = () => import('./Roster.vue')
const Invite = () => import('./Invite.vue')
const Reports = () => import('./Reports.vue')

const Groups = {
  List,
  Edit,
  Show,
  Admin,
  Dashboard,
  Roster,
  Invite,
  Reports
}

export default Groups
